/* Zayla mega menu — hover grace period (Casey 7/26).
   Broadcast's <hover-disclosure> closes its dropdown the instant the pointer
   leaves the nav item, so a fast diagonal from the nav link toward the far
   side of the open panel clips across other header elements for a moment and
   the menu vanishes. Patch: delay hideDisclosure by 350ms; cancel the close if
   the pointer re-enters the item or its panel; flush any pending close the
   moment another menu opens so two panels never overlap. */
(function () {
  'use strict';
  if (window.zmvGraceInit) return;
  window.zmvGraceInit = true;
  var GRACE = 350;

  customElements.whenDefined('hover-disclosure').then(function () {
    var HD = customElements.get('hover-disclosure');
    if (!HD || HD.prototype._zmvGraced) return;
    var proto = HD.prototype;
    proto._zmvGraced = true;

    var origHide = proto.hideDisclosure;
    var origShow = proto.showDisclosure;

    proto._zmvClear = function () {
      if (this._zmvT) { clearTimeout(this._zmvT); this._zmvT = null; }
      if (this._zmvCancel) { this._zmvCancel(); this._zmvCancel = null; }
    };

    proto._zmvFlush = function () {
      this._zmvClear();
      origHide.call(this);
    };

    proto.hideDisclosure = function () {
      var el = this;
      el._zmvClear();
      var onBack = function () {
        if (el._zmvT) { clearTimeout(el._zmvT); el._zmvT = null; }
        el.removeEventListener('mouseenter', onBack);
        el._zmvCancel = null;
      };
      el._zmvCancel = function () { el.removeEventListener('mouseenter', onBack); };
      el.addEventListener('mouseenter', onBack);
      el._zmvT = setTimeout(function () {
        el.removeEventListener('mouseenter', onBack);
        el._zmvCancel = null;
        el._zmvT = null;
        origHide.call(el);
      }, GRACE);
    };

    proto.showDisclosure = function (t) {
      var self = this;
      // pin the page-dim scrim to the header's live bottom edge (announcement bar
      // scrolls away, header shrinks when stuck — measure, don't guess)
      var hdr = document.querySelector('.theme__header');
      if (hdr) document.documentElement.style.setProperty('--zmv-scrim-top', Math.round(hdr.getBoundingClientRect().bottom) + 'px');
      document.querySelectorAll('hover-disclosure').forEach(function (o) {
        if (o !== self && o._zmvT) o._zmvFlush();
      });
      this._zmvClear();
      return origShow.call(this, t);
    };
  });
})();
